/**
 * [统一处理某方法promise的catch]
 * @param  {any} obj
 */
export function catchNoErr(obj) {
    var newObj = obj
        .then(function (res) {
        return res;
    })
        .catch(function (err) {
        throw err;
    });
    newObj.oldThen = newObj.then;
    newObj.then = function (onFulfilled, onRejected) {
        return newObj.oldThen(onFulfilled, onRejected ||
            function () { });
    };
    return newObj;
}
